import React, { useEffect, useState, useRef, useMemo } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import { get_customer_sales_reports } from "../../../Controllers/Dashboard/Dashboard";
import { Button } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import ReactToPrint from "react-to-print";
import formatDateDDMMYYYY from "../../../Main/formatDate";

const SalesReport = () => {
  let location = useLocation();
  let componentRef = useRef();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [role, setRole] = useState("");

  const headers = {
    name: "Sales & Returns Report",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search by Invoice, Customer Name, Phone, Code",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: "0", label: "Date (Oldest-Newest)" },
          { value: "1", label: "Date (Newest-Oldest)" },
          { value: "2", label: "Price (Low-High)" },
          { value: "3", label: "Price (High-Low)" },
        ],
      },
      /* {
        type: "filter",
        name: "customer",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Customer",
        api: "get-all-customers",
        value: null,
        options: null,
      }, */
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "select",
        name: "type",
        placeholder: "Type",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: "sale", label: "Sale Only" },
          { value: "return", label: "Return Only" },
          { value: "both", label: "Both" },
        ],
      },
      /*  {
         type: "select",
         name: "status",
         placeholder: "Status",
         value: null,
         allowClear: true,
         showSearch: false,
         filterOption: true,
         options: [
           { value: "1", label: "Active" },
           { value: "0", label: "Inactive" },
           { value: 2, label: "All" },
         ],
       }, */
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
      {
        type: "select",
        name: "payment_status",
        placeholder: "Payment Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Unpaid" },
          { value: 1, label: "Partial" },
          { value: 2, label: "Paid" },
          { value: 3, label: "All" },
        ],
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Sales & Returns",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Sales" },
        { value: 0, label: "Returns" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        branch: tabledata?.branch,
        type: tabledata?.type || "both",
        payment_status: tabledata?.payment_status,
        status: tabledata?.status,
        date: tabledata?.date,
      };

      const products = await get_customer_sales_reports(data);
      if (products?.status) {
        setBody(products?.data);
        setRole(products?.data?.role);

        // Update header totals
        const updatedHeader = { ...header };
        if (products?.data?.reports) {
          const reports = products.data.reports;
          const totalSales = reports.filter(r => r.type === 'sale').length;
          const totalReturns = reports.filter(r => r.type === 'return').length;

          updatedHeader.navigate.total = [
            { value: reports.length, label: "Total" },
            { value: totalSales, label: "Sales" },
            { value: totalReturns, label: "Returns" },
          ];
        }
        setHeader(updatedHeader);

        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  const downloadCSV = () => {
    if (!body || !body.reports || body.reports.length === 0) {
      toast.error("No data available to download");
      return;
    }

    try {
      const header = [
        "Type", "Invoice",  "Customer", "Customer Phone", "Customer Code",
        "Branch", "Date", "Cash", "Card", "Bank Transfers", "Online", "Cheque",
        "Paid", "Payable", "Subtotal", "Discount", "Tax", "Total", "Status"
      ];

      const rows = body.reports.map((item) => {
        const row = [
          item?.type === 'return' ? 'RETURN' : 'SALE',
          item?.number ? `#INV-${item.number}` : "-",
          item?.customer?.name || "-",
          item?.customer?.phone || "-",
          item?.customer?.code || "-",
          item?.branch?.name || "-",
          formatDate(item?.date),
          item?.total_cash?.toFixed?.(3) || 0,
          (
            (item?.total_debit_card || 0) +
            (item?.total_credit_card || 0)
          ).toFixed(3),
          item?.total_bank_transfer?.toFixed?.(3) || 0,
          item?.total_online_payment?.toFixed?.(3) || 0,
          item?.total_cheque?.toFixed?.(3) || 0,
          item?.total_paid?.toFixed?.(3) || 0,
          item?.total_payable?.toFixed?.(3) || 0,
          item?.subtotal?.toFixed?.(3) || 0,
          item?.discount?.toFixed?.(3) || 0,
          item?.taxamount?.toFixed?.(3) || 0,
          item?.total?.toFixed?.(3) || 0,
          item?.status === 1 ? 'Active' : 'Inactive'
        ];
        return row;
      });

      const csvContent = [header, ...rows]
        .map(row => row.map(field => `"${field}"`).join(","))
        .join("\n");

      const encoder = new TextEncoder();
      const encodedContent = encoder.encode('\uFEFF' + csvContent);

      const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `Sales_Returns_Report_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = () => {
    if (!body || !body.reports || body.reports.length === 0) {
      toast.error("No data available to download");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    registerCairoFont(doc);
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFont("Cairo-Bold", "bold");
    doc.setFontSize(18);
    doc.text("Sales & Returns Report", pageWidth / 2, 18, { align: "center" });

    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB");
    const formattedTime = now.toLocaleTimeString();
    doc.setFontSize(10);
    doc.text(`Downloaded on: ${formattedDate} ${formattedTime}`, pageWidth / 2, 26, { align: "center" });

    const tableRows = body.reports.map((item) => [
      item?.type === 'return' ? 'RETURN' : 'SALE',
      item?.number ? `#INV-${item.number}` : "-",
      item?.customer?.name || "-",
      item?.customer?.phone || "-",
      item?.branch?.name || "-",
      formatDate(item?.date),
      item?.total_cash?.toFixed?.(3) || 0,
      item?.total_debit_card?.toFixed?.(3) || 0,
      item?.total_credit_card?.toFixed?.(3) || 0,
      item?.total_bank_transfer?.toFixed?.(3) || 0,
      item?.total_online_payment?.toFixed?.(3) || 0,
      item?.total_cheque?.toFixed?.(3) || 0,
      item?.total_paid?.toFixed?.(3) || 0,
      item?.total_payable?.toFixed?.(3) || 0,
      item?.subtotal?.toFixed?.(3) || 0,
      item?.discount?.toFixed?.(3) || 0,
      item?.taxamount?.toFixed?.(3) || 0,
      item?.total?.toFixed?.(3) || 0,
      item?.status === 1 ? 'Active' : 'Inactive'
    ]);

    autoTable(doc, {
      startY: 32,
      head: [[
        "Type", "Invoice", "Customer", "Phone", "Branch", "Date",
        "Cash", "Debit", "Credit", "Bank Transfers", "Online", "Cheque",
        "Paid", "Payable", "Subtotal", "Discount", "Tax", "Total", "Status"
      ]],
      body: tableRows,
      styles: {
        font: "Cairo",
        textColor: [0, 0, 0],
        lineColor: [7, 181, 83],
        lineWidth: 0.2
      },
      headStyles: {
        font: "Cairo",
        fontStyle: "bold",
        fillColor: false,
        lineColor: [7, 181, 83],
        lineWidth: 0.6
      },
    });

    doc.save(`Sales_Returns_Report_${formattedDate}.pdf`);
  };

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch"
      );
    }

    setHeader(updatedHeader);
  }, [role]);


  const groupedReports = useMemo(() => {
    if (!body?.reports) return [];
    const salesMap = new Map();
    const returnsMap = new Map();
    const result = [];

    body.reports.forEach(report => {
      const invoiceNum = report.number;
      if (report.type === 'sale') {
        if (!salesMap.has(invoiceNum)) {
          salesMap.set(invoiceNum, []);
        }
        salesMap.get(invoiceNum).push(report);
      } else if (report.type === 'return') {
        if (!returnsMap.has(invoiceNum)) {
          returnsMap.set(invoiceNum, []);
        }
        returnsMap.get(invoiceNum).push(report);
      }
    });

    const allInvoiceNumbers = new Set([
      ...salesMap.keys(),
      ...returnsMap.keys()
    ]);

    const sortedInvoices = Array.from(allInvoiceNumbers).sort((a, b) => {
      const numA = parseInt(a) || 0;
      const numB = parseInt(b) || 0;
      return numA - numB;
    });

    sortedInvoices.forEach(invoiceNum => {
      const sales = salesMap.get(invoiceNum) || [];
      const returns = returnsMap.get(invoiceNum) || [];

      sales.forEach(sale => result.push(sale));

      returns.forEach(returnItem => result.push(returnItem));
    });

    return result;
  }, [body?.reports]);

  const calculateNetTotals = () => {
    if (!body?.reports) return {};

    let totals = {
      cash: 0,
      debit: 0,
      credit: 0,
      bank: 0,
      online: 0,
      cheque: 0,
      paid: 0,
      payable: 0,
      subtotal: 0,
      discount: 0,
      tax: 0,
      total: 0
    };

    body.reports.forEach(report => {
      const multiplier = report.type === 'return' ? -1 : 1;

      totals.cash += (parseFloat(report?.total_cash) || 0) * multiplier;
      totals.debit += (parseFloat(report?.total_debit_card) || 0) * multiplier;
      totals.credit += (parseFloat(report?.total_credit_card) || 0) * multiplier;
      totals.bank += (parseFloat(report?.total_bank_transfer) || 0) * multiplier;
      totals.online += (parseFloat(report?.total_online_payment) || 0) * multiplier;
      totals.cheque += (parseFloat(report?.total_cheque) || 0) * multiplier;
      totals.paid += (parseFloat(report?.total_paid) || 0) * multiplier;
      totals.payable += (parseFloat(report?.total_payable) || 0) * multiplier;
      totals.subtotal += (parseFloat(report?.subtotal) || 0) * multiplier;
      totals.discount += (parseFloat(report?.discount) || 0) * multiplier;
      totals.tax += (parseFloat(report?.taxamount) || 0) * multiplier;
      totals.total += (parseFloat(report?.total) || 0) * multiplier;
    });

    return totals;
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div className="text-right flex gap-3 justify-end mt-4">
          <Button
            className="mr-2  !bg-[#0dacce] !border-[#0dacce] hover:!bg-[#0b9abb] hover:!border-[#0b9abb]"
            type="primary"
            onClick={downloadCSV}
          >
            Download CSV
          </Button>

          <ReactToPrint
            trigger={() => (
              <Button
                className="mr-2  !bg-[#0dacce] !border-[#0dacce] hover:!bg-[#0b9abb] hover:!border-[#0b9abb]"
                type="primary"
              >
                Download PDF
              </Button>
            )}
            content={() => componentRef}
            pageStyle={`
              @page {
                size: landscape;
                margin: 10mm;
              }

              @media print {
                tfoot {
                  position: static !important;
                  bottom: auto !important;
                }
                thead { 
                  display: table-header-group !important;
                }
                tfoot {
                  display: table-row-group !important;
                }
              }

              table {
                border-collapse: collapse;
                width: 100%;
                font-size: 12px;
              }
              th, td {
                border: 1px solid #ddd;
                padding: 6px;
              }
              th {
                background-color: #f4f4f4;
              }
              @media print {
                table, thead, tbody, tfoot, tr, th, td {
                  border: 1px solid #000 !important;
                  border-collapse: collapse !important;
                }
                th {
                  background-color: #f4f4f4 !important;
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                }
                table {
                  width: 100% !important;
                  border-collapse: collapse !important;
                }
                thead, tfoot {
                  position: static !important;
                }
              }
            `}
          />
        </div>

        <ScrollWrapper>
          <div
            className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
            ref={(el) => (componentRef = el)}
          >
            <table className="w-full bg-white">
              <thead className="text-gray-500 sticky top-0 bg-white z-10">
                <tr>
                  <th className="border p-2">Type</th>
                  <th className="border p-2">Invoice</th>
                  <th className="border p-2">Customer</th>
                  <th className="border p-2">Phone</th>
                  <th className="border p-2">Code</th>
                  <th className="border p-2">Branch</th>
                  <th className="border p-2">Date</th>
                  <th className="border p-2">Cash</th>
                  <th className="border p-2">Card</th>
                  <th className="border p-2">Bank Transfers</th>
                  <th className="border p-2">Online</th>
                  <th className="border p-2">Cheque</th>
                  <th className="border p-2">Paid</th>
                  <th className="border p-2">Payable</th>
                  <th className="border p-2">Subtotal</th>
                  <th className="border p-2">Discount</th>
                  <th className="border p-2">Tax&nbsp;[VAT]</th>
                  <th className="border p-2">Total</th>
                  <th className="border p-2">Payment Status</th>
                </tr>
              </thead>
              <tbody>
                {groupedReports?.map((value, index) => (
                  <tr key={index} className={value.type === 'return' ? 'bg-red-50' : ''}>
                    <td className="border p-2">
                      <span className={`px-2 py-1 rounded ${value.type === 'return' ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
                        {value.type === 'return' ? 'RETURN' : 'SALE'}
                      </span>
                    </td>
                    <td className="border p-2">#INV {value?.number}</td>
                    <td className="border p-2">{value?.customer?.name}</td>
                    <td className="border p-2">{value?.customer?.phone || '-'}</td>
                    <td className="border p-2">{value?.customer?.code || '-'}</td>
                    <td className="border p-2">{value?.branch?.name}</td>
                    <td className="border p-2">
                      {value?.date ? formatDateDDMMYYYY(value?.date) : ""}
                    </td>
                    <td className="border p-2">
                      {value?.total_cash?.toFixed?.(3)}
                    </td>
                    <td className="border p-2">
                      {(
                        (value?.total_debit_card || 0) +
                        (value?.total_credit_card || 0)
                      ).toFixed(3)}
                    </td>

                    <td className="border p-2">
                      {value?.total_bank_transfer?.toFixed?.(3)}
                    </td>
                    <td className="border p-2">
                      {value?.total_online_payment?.toFixed?.(3)}
                    </td>
                    <td className="border p-2">
                      {value?.total_cheque?.toFixed?.(3)}
                    </td>
                    <td className="border p-2">
                      {value?.total_paid?.toFixed?.(3)}
                    </td>
                    <td className="border p-2">
                      {value?.total_payable?.toFixed?.(3)}
                    </td>
                    <td className="border p-2">
                      {value?.subtotal?.toFixed?.(3)}
                    </td>
                    <td className="border p-2">
                      {value?.discount?.toFixed?.(3)}
                    </td>
                    <td className="border p-2">
                      {value?.taxamount?.toFixed?.(3)}
                    </td>
                    <td className="border p-2">
                      {value?.total?.toFixed?.(3)}
                    </td>
                    <td className="border p-2">
                      <span className={`px-2 py-1 rounded ${value.payment_status === 0
                        ? 'bg-red-100 text-red-800'
                        : value.payment_status === 1
                          ? 'bg-yellow-100 text-yellow-800'
                          : 'bg-green-100 text-green-800'
                        }`}>
                        {value.payment_status === 0 ? 'Unpaid' : value.payment_status === 1 ? 'Partial' : 'Paid'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="sticky bottom-0 bg-white z-10">
                <tr className="text-sm font-medium bg-gray-50">
                  <td className="border p-2 font-bold" colSpan="7">NET TOTALS (Sales - Returns)</td>
                  {/* <td className="border p-2 font-bold"></td> */}
                  <td className="border p-2 font-bold">
                    {calculateNetTotals().cash?.toFixed(3)}
                  </td>
                  <td className="border p-2 font-bold">
                    {(
                      (calculateNetTotals().debit || 0) +
                      (calculateNetTotals().credit || 0)
                    ).toFixed(3)}

                  </td>
                  <td className="border p-2 font-bold">
                    {calculateNetTotals().bank?.toFixed(3)}
                  </td>
                  <td className="border p-2 font-bold">
                    {calculateNetTotals().online?.toFixed(3)}
                  </td>
                  <td className="border p-2 font-bold">
                    {calculateNetTotals().cheque?.toFixed(3)}
                  </td>
                  <td className="border p-2 font-bold">
                    {calculateNetTotals().paid?.toFixed(3)}
                  </td>
                  <td className="border p-2 font-bold">
                    {calculateNetTotals().payable?.toFixed(3)}
                  </td>
                  <td className="border p-2 font-bold">
                    {calculateNetTotals().subtotal?.toFixed(3)}
                  </td>
                  <td className="border p-2 font-bold">
                    {calculateNetTotals().discount?.toFixed(3)}
                  </td>
                  <td className="border p-2 font-bold">
                    {calculateNetTotals().tax?.toFixed(3)}
                  </td>
                  <td className="border p-2 font-bold">
                    {calculateNetTotals().total?.toFixed(3)}
                  </td>
                  <td></td>
                </tr>
              </tfoot>

            </table>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default SalesReport;